import axios from 'axios'; // 引入axios
import { saveTheCookie } from '../util/util';

axios.defaults.withCredentials = true;
const fetch = axios.create({
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  timeout: 5000,
});
// Astro退出应用
export const astroQuitApplication = () => {
  saveTheCookie();
  fetch({
    url: 'http://127.0.0.1:11111/jsonrpc',
    method: 'post',
    data: {
      jsonrpc: '2.0',
      id: 1,
      method: 'Controller.1.deactivate',
      params: {
        callsign: 'WebKitBrowser',
      },
    },
  });
};
